





















































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { ICustomStylingClass } from "@/components/Globals/types/custom.t";
import CustomButton from "@/components/Globals/CustomButton.vue";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomText from "@/components/Globals/CustomText.vue";
import CustomImage from "@/components/Globals/CustomImage.vue";
import CustomSvgIcon from "@/components/Globals/CustomSvgIcon.vue";

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomText,
    CustomImage,
    CustomSvgIcon,
  },
})
export default class ModalHeader extends Vue {
  @Prop()
  buttonText?: string;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop({ default: false })
  includeBack!: boolean;

  @Prop({ default: true })
  includeClose!: boolean;

  @Prop()
  modalTitle?: string;

  @Prop({ default: false })
  headerImg!: boolean;

  @Prop({ default: false })
  backDisabled!: boolean;

  @Prop({ default: false })
  closeDisabled!: boolean;

  get assetsPath() {
    const { endPoints } = this.$store.state;

    return endPoints.customizer.customsAssets || endPoints.ugcentrypoint.customsAssets;
  }

	get translations() {
		return this.$store.state.translations.data;
	}

  @Emit('backEvent')
  backEvent() {}

  @Emit('closeEvent')
  closeEvent() {}
}
